<template>
    <div class="erm_wrapper">

        <AppModal :title="'Add New Coupon Item'" :width="700" :showFooter="false" ref="add_coupon_modal">
            <template #body>
                <AddCoupon @updateDataAfterNewAdd="updateDataAfterNewAdd"/>
            </template>
        </AppModal>

        <AppTable :tableData="coupons" v-loading="loading">
            <template #header>
                <h1 class="table-title">All Coupon Item</h1>
                <el-button @click="OpenMenuAddModal()" size="large" type="primary" icon="Plus" class="ltm_button">
                    Add New Coupon Item
                </el-button>
            </template>

            <template #filter>
                <el-input class="easyRestaurantManager-search-input erm_input" v-model="search" style="width: 240px" size="large"
                    placeholder="Please Input" prefix-icon="Search" />
            </template>

            <template #columns>
                <el-table-column prop="id" label="ID" width="60" />
                <el-table-column prop="name" label="Coupon Name" width="auto" />
                <el-table-column prop="code" label="Code" width="auto" />
                <el-table-column prop="discount_type" label="Discount Type" width="auto" />
                <el-table-column prop="discount_value" label="Discount" width="auto" />
                <el-table-column prop="status" label="status" width="auto" />
                <el-table-column prop="added_date" label="Added Date " width="auto" />
                <el-table-column prop="expiration_date" label="Expiration Date " width="auto" />
                <el-table-column label="Operations" width="120">
                    <template #default="{ row }">
                        <el-tooltip class="box-item" effect="dark" content="Click to edit coupons" placement="top-start">
                            <el-button @click="openUpdateCouponModal(row)" class="erm_box_icon" link size="small">
                                <Icon icon="easyRestaurantManager-edit" />
                            </el-button>
                        </el-tooltip>
                        <el-tooltip class="box-item" effect="dark" content="Click to delete coupons"
                            placement="top-start">
                            <el-button @click="openDeleteCouponModal(row)" class="erm_box_icon" link size="small">
                                <Icon icon="easyRestaurantManager-delete" />
                            </el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </template>

            <template #footer>
                <el-pagination v-model:current-page="currentPage" v-model:page-size="pageSize"
                    :page-sizes="[10, 20, 30, 40]" large :disabled="total_coupon <= pageSize" background
                    layout="total, sizes, prev, pager, next" :total="+total_coupon" />
            </template>

        </AppTable>

        <AppModal :title="'Update Coupon'" :width="800" :showFooter="false" ref="update_coupon_modal">
            <template #body>
                <AddCoupon :coupons_data="coupon" />
            </template>
        </AppModal>

        <AppModal :title="'Delete Coupon'" :width="500" :showFooter="false" ref="delete_coupon_modal">
            <template #body>

                <div class="delete-modal-body">
                    <h1>Are you sure ?</h1>
                    <p>You want to delete this coupon</p>
                </div>
            </template>
            <template #footer>
                <div class="easyRestaurantManager-modal-footer">
                    <el-button @click="$refs.delete_coupon_modal.handleClose()" type="default"
                        size="medium">Cancel</el-button>
                    <el-button @click="deleteCoupon" type="primary" size="medium">Delete</el-button>
                </div>
            </template>
        </AppModal>

    </div>
</template>

<script>
import axios from 'axios';

import AppTable from "../../components/AppTable.vue";
import Icon from "../../components/Icons/AppIcon.vue";
import AppModal from "../../components/AppModal.vue";
import AddCoupon from "./AddCoupon.vue";
export default {
    components: {
        AppTable,
        Icon,
        AppModal,
        AddCoupon
    },
    data() {
        return {
            search: '',
            coupons: [],
            coupon: {},
            total_coupon: 0,
            loading: false,
            add_coupon_modal: false,
            currentPage: 1,
            pageSize: 10,
            active_id: null,
            rest_api: window.RestaurantMenuMangeData.rest_api,
        }
    },
    methods:{
       
        OpenMenuAddModal(){
            this.$refs.add_coupon_modal.openModel();
        },

        async getCoupon(){
            this.loading = true;
            try {
                const response = await axios.get(`${this.rest_api}/getCoupon`);
                this.coupons = response.data?.coupons;
                this.loading = false;
            } catch (error) {
                this.loading = false;
                console.error('Error fetching couriers:',);
            }
        },

        openDeleteCouponModal(row) {
            this.active_id = row.id;
            this.$refs.delete_coupon_modal.openModel();
        },
        async deleteCoupon() {
            try {
                const response = await axios.post(`${this.rest_api}/deleteCoupon`, { id: this.active_id });
                this.getCoupon();
                this.$refs.delete_coupon_modal.handleClose();
            } catch (error) {
                console.error('Error fetching couriers:',);
            }
        },
        openUpdateCouponModal(row) {
            this.coupon = row;
            this.$refs.update_coupon_modal.openModel();
        },

        updateDataAfterNewAdd(new_coupon) {
            this.$refs.add_coupon_modal.handleClose();
            this.coupons.unshift(new_coupon);
        },
    },
    mounted(){
            this.getCoupon();
    }


}
</script>